import React, { useCallback, useEffect, useMemo, useState } from "react"
// import LicenseNeededModal from "../components/Licences/LicenseNeededModal"
import TeensLicenseModal from "../components/Licences/teens"
import KidsLicenseModal from "../components/Licences/kids"
import KidsSchoolLicenseModal from "../components/Licences/kids/school"
import PayLicenseAlert from "../components/Licences/PayLicenseAlert"
import useApi from "modules/licenses"
import { useAuthContext } from "./AuthContext"
// import SchoolLicenseNeededModal from "components/Licences/SchoolLicenseNeededModal"
import TeacherMessage from "components/Tools/TeacherMessage"
import SchoolLicenseAlert from "components/Licences/SchoolLicenseAlert"
import { useNavigate } from "react-router-dom"
import { routes } from "common/navigationRoutes"
import { LOCAL_STORAGE_PREFIX } from "common/constants"
import { useAlertQueue } from "./AlertQueueContext"
import storage from "utils/persistentStorage"
import { useTranslation } from "react-i18next"
import withReactContent from "sweetalert2-react-content"
import Swal from "sweetalert2"

export const LicenceContext = React.createContext()

export const useLicenceContext = () => {
  const context = React.useContext(LicenceContext)
  if (!context) {
    throw new Error("useLicenceContext must be used within a LicenceProvider")
  }
  return context
}

const currency = ["", "USD", "MEX", "CAD"]

const LicenceProvider = ({ children }) => {
  const { t } = useTranslation()
  const [showAlert, setShowAlert] = useState(false)
  const [showSchoolAlert, setShowSchoolAlert] = useState(false)
  const [orderData, setOrderData] = useState(null)
  const [licenceDaysLeft, setLicenceDaysLeft] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [showSchoolModal, setShowSchoolModal] = useState(false)
  const [openTeacherMessages, setOpenTeacherMessages] = useState(false)
  const [shouldTakeScreenshot, setShouldTakeScreenshot] = useState(false)
  const [productPrice, setProductPrice] = useState(0)
  const [currencyCode, setCurrencyCode] = useState("")
  const { getLicenseStatus, addOrder } = useApi()
  const { selectedGroupData, userData, accountType } = useAuthContext()
  const [isB2C, setIsB2C] = useState(false)
  const navigate = useNavigate()
  const { activeId } = useAlertQueue()
  const MySwal = withReactContent(Swal)
  const ModalComponent = accountType < 7 ? KidsLicenseModal : TeensLicenseModal
  const SchoolModalComponent =
    accountType < 7 ? KidsSchoolLicenseModal : KidsSchoolLicenseModal

  useEffect(() => {
    setShowAlert(false)
    setShowSchoolAlert(false)
    setShowModal(false)
    setShowSchoolModal(false)
    setOpenTeacherMessages(false)
    setShouldTakeScreenshot(false)
    setOrderData(null)
    setLicenceDaysLeft(10)
    setProductPrice(0)
    setCurrencyCode("")
  }, [])

  const checkLicenseStatus = useCallback(async () => {
    if (!selectedGroupData?.groupId || selectedGroupData?.groupId < 0) return
    const cacheStatus = await storage.getItem(
      `${LOCAL_STORAGE_PREFIX}licenseStatus_${userData?.userId}`
    )
    if (cacheStatus) {
      const response = cacheStatus
      evalStatus({ data: response })
    } else {
      getLicenseStatus({ groupId: selectedGroupData?.groupId }).then(
        (response) => {
          evalStatus(response)
        }
      )
    }
  }, [selectedGroupData?.groupId])

  const evalStatus = (response) => {
    console.log("License status:", response?.data)
    if (!response?.data) return
    // cache license status in localstorage
    const licenseStatusData = response?.data
    if (licenseStatusData !== null) {
      licenseStatusData.lastUpdate = new Date().toISOString()
      storage.setItem(
        `${LOCAL_STORAGE_PREFIX}licenseStatus_${userData?.userId}`,
        licenseStatusData
      )
    }
    if (
      response?.data?.order &&
      response?.data?.order?.licenseOrderStatusId !== 13
    ) {
      setOrderData({
        ...response.data.order,
        currency: currency[response.data.order.currencyId] || "",
      })
      const finalDaysLeft =
        response.data.order.daysLeft < 0
          ? 0
          : response.data.order.daysLeft === 0
          ? 1
          : response.data.order.daysLeft
      setLicenceDaysLeft(finalDaysLeft)
    } else {
      setOrderData(null)
      setLicenceDaysLeft(10)
    }
    let showLicenseModal = false
    if (!response?.data?.isLicensed) {
      setIsB2C(response?.data?.isB2C || false)
      if (response?.data?.licenseRequired?.price) {
        setProductPrice(response.data.licenseRequired.price)
        setCurrencyCode(
          currency[response.data.licenseRequired.currencyId] || ""
        )
      }
      if (response?.data?.payeeTypeId === 1 || response?.data?.isB2C) {
        setShowSchoolModal(true)
        showLicenseModal = true
      } else {
        setShowModal(true)
        showLicenseModal = true
      }
    } else {
      if (response?.data?.order?.licenseOrderStatusId === 4) {
        // license is paid
        setShowAlert(false)
        setShowSchoolAlert(false)
        setShowAlert(false)
        setShowSchoolAlert(false)
        return
      }
    }
    if (!showLicenseModal && response?.data?.order !== null) {
      setShowModal(true)
    }
  }

  const generateLicenseOrder = () => {
    if (orderData === null) {
      addOrder({ groupId: selectedGroupData?.groupId }).then((response) => {
        console.log("order status:", response?.data)
        if (response?.data?.status) {
          setOrderData({
            ...response.data.order,
            currency: currency[response.data.order.currencyId] || "",
          })
        }
      })
    }
  }

  const openInvoice = () => {
    if (orderData?.reference) {
      let url = `/payments/Invoice?folio=${orderData.reference}`
      if (process.env.REACT_APP_ENVIORNMENT !== "development") {
        url = "/v2" + url
      }
      window.open(url, "_blank")
    } else {
      addOrder({ groupId: selectedGroupData?.groupId }).then((response) => {
        console.log("order status:", response?.data)
        if (response?.data?.order?.reference) {
          setOrderData({
            ...response.data.order,
            currency: currency[response.data.order.currencyId] || "",
          })
          setShowModal(false)
          setShowAlert(true)
          let url = `/payments/Invoice?folio=${response.data.order.reference}`
          if (process.env.REACT_APP_ENVIORNMENT !== "development") {
            url = "/v2" + url
          }
          const newWindow = window.open(url, "_blank")
          if (
            !newWindow ||
            newWindow.closed ||
            typeof newWindow.closed === "undefined"
          ) {
            MySwal.fire({
              text: t(
                "clic_continue_to_secure_payment",
                "Please click continue to securely complete your payment."
              ),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: t("Continue"),
              cancelButtonText: t("Cancel"),
            }).then((popupResult) => {
              if (popupResult.isConfirmed) {
                window.open(url, "_blank")
              }
            })
          }
        }
      })
    }
  }

  const onTeacherMessage = useCallback(() => {
    // take screenshot of current page using html2canvas
    setShouldTakeScreenshot(true)
    setShowSchoolModal(false)
    setShowSchoolAlert(false)
    setOpenTeacherMessages(true)
  }, [])

  const onTeacherMessageClosed = useCallback(() => {
    setShouldTakeScreenshot(false)
    setOpenTeacherMessages(false)
  }, [])

  const openMembershipsPage = () => {
    // navigate to /account
    setShowSchoolModal(false)
    setShowSchoolAlert(false)
    navigate(routes.ACCOUNT)
  }

  const value = useMemo(
    () => ({
      showAlert,
      licenceDaysLeft,
      orderData,
      productPrice,
      currencyCode,
      isLicenseVisible:
        showModal ||
        showSchoolModal ||
        showAlert ||
        showSchoolAlert ||
        openTeacherMessages,
      isB2C,
      setShowAlert,
      setLicenceDaysLeft,
      checkLicenseStatus,
      openInvoice,
      openMembershipsPage,
      onTeacherMessage,
    }),
    [
      showAlert,
      licenceDaysLeft,
      orderData,
      checkLicenseStatus,
      productPrice,
      currencyCode,
      showModal,
      showSchoolModal,
      showSchoolAlert,
      onTeacherMessage,
      isB2C,
    ]
  )
  return (
    <LicenceContext.Provider value={value}>
      {children}
      <ModalComponent
        open={showModal && (!activeId || activeId === null)}
        onClose={() => {
          setShowModal(false)
          setShowAlert(true)
          generateLicenseOrder()
        }}
      />
      {/* <LicenseNeededModal
        open={showModal && (!activeId || activeId === null)}
        onClose={() => {
          setShowModal(false)
          setShowAlert(true)
          generateLicenseOrder()
        }}
      /> */}
      <SchoolModalComponent
        open={showSchoolModal && (!activeId || activeId === null)}
        onClose={() => {
          setShowSchoolModal(false)
          setShowSchoolAlert(true)
        }}
        onContactTeacher={() => {
          if (isB2C) {
            openMembershipsPage()
            return
          }
          onTeacherMessage()
        }}
      />
      <TeacherMessage
        open={openTeacherMessages && (!activeId || activeId === null)}
        onClose={onTeacherMessageClosed}
        takeScreenshot={shouldTakeScreenshot}
      />
      {showAlert && !showModal && (
        <PayLicenseAlert onClose={() => setShowAlert(false)} />
      )}
      {showSchoolAlert && !showSchoolModal && (
        <SchoolLicenseAlert onClose={() => setShowSchoolAlert(false)} />
      )}
    </LicenceContext.Provider>
  )
}

export default LicenceProvider
